module.exports = __webpack_public_path__ + "img/top.e7c95198.jpg";